"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[865],{

/***/ 93058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CN": function() { return /* binding */ formatPhone; },
/* harmony export */   "Tp": function() { return /* binding */ formatCurrencyWithSybmol; }
/* harmony export */ });
/* unused harmony exports formatNumber, formatCurrency, getDirection, trimPersonalId */
function formatNumber(value) {
  var maximumFractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var num = typeof value == "string" ? parseFloat(value) : value;
  return isNaN(num) ? value.toString() : Intl.NumberFormat("he-IL", {
    maximumFractionDigits: maximumFractionDigits
  }).format(num);
}
var formatPhone = function formatPhone(number) {
  return number.replace(/^(\d{2,3})(\d{7})$/, "$1-$2");
};
function formatCurrency(value) {
  var maximumFractionDigits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return Intl.NumberFormat("he-IL", {
    maximumFractionDigits: maximumFractionDigits
  }).format(value);
}
var formatCurrencyWithSybmol = function formatCurrencyWithSybmol(value) {
  var currencySymbol = "₪";
  if ((value === null || value === void 0 ? void 0 : value.length) === 0 || value === "₪") return "";

  if (value !== null && value !== void 0 && value.toString().startsWith(currencySymbol)) {
    return value;
  }

  return "".concat(currencySymbol).concat(value);
};
var startsWithHebrewRegex = /^[\u0590-\u05fe]/;
function getDirection(unit) {
  return startsWithHebrewRegex.test(unit) ? "rtl" : "ltr";
}
var trimPersonalId = function trimPersonalId(number) {
  return number === null || number === void 0 ? void 0 : number.replace(/^0+/, "");
};

/***/ }),

/***/ 80865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OtpStep_OtpPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Link/Link.js
var Link = __webpack_require__(89659);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(50253);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/@mui/utils/esm/visuallyHidden.js
var visuallyHidden = __webpack_require__(13113);
// EXTERNAL MODULE: ./api/index.ts + 2 modules
var api = __webpack_require__(91315);
// EXTERNAL MODULE: ./common/utils/formatters.ts
var formatters = __webpack_require__(93058);
// EXTERNAL MODULE: ./components/GenericButton/GenericButton.tsx
var GenericButton = __webpack_require__(92208);
// EXTERNAL MODULE: ./components/QuickPurchasePage/QuickPurchaseContext.tsx
var QuickPurchaseContext = __webpack_require__(98968);
// EXTERNAL MODULE: ./components/Reusable/Bit/NextLink.tsx
var NextLink = __webpack_require__(16110);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js + 3 modules
var esm = __webpack_require__(34853);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
// EXTERNAL MODULE: ./components/Icons/BackIcon.tsx
var BackIcon = __webpack_require__(2936);
// EXTERNAL MODULE: ./components/OtpStep/OtpContext.tsx
var OtpContext = __webpack_require__(78461);
// EXTERNAL MODULE: ./node_modules/react-verification-code-input/dist/index.es.js
var index_es = __webpack_require__(2461);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/OtpStep/StyledCodeInput.tsx




var StyledeInput = (0,styled_components_browser_esm/* default */.ZP)(index_es/* default */.Z).withConfig({
  displayName: "StyledCodeInput__StyledeInput",
  componentId: "sc-mrn29p-0"
})(["width:100% !important;margin-top:4px;margin-bottom:4px;& > div{& > input{font-family:\"NarkisBlock\" !important;font-size:24px;border-top-left-radius:8px !important;border-top-right-radius:8px !important;border-bottom-left-radius:8px !important;border-bottom-right-radius:8px !important;border-right:solid 1px #e5e5e5 !important;border-left:solid 1px #e5e5e5 !important;border:", " !important;background-color:#fff;margin-left:8px;color:#000;&:first-child{margin-left:0 !important;}&:focus{box-shadow:none;border:1px solid var(--Yellow,#ffbc0d);border-right:solid 1px #ffbc0d !important;border-left:solid 1px #ffbc0d !important;}", "{width:48px !important;height:56px !important;}border-radius:8px;}}"], function (p) {
  return p.$submitError ? "solid 1px rgba(215, 2, 2, 0.5)" : "solid 1px #E5E5E5;";
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledCodeWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "StyledCodeInput__StyledCodeWrapper",
  componentId: "sc-mrn29p-1"
})(["margin:8px auto 15px;width:max-content;direction:ltr;"]);

var StyledCodeInput = function StyledCodeInput(_ref) {
  var setSubmitCode = _ref.setSubmitCode,
      setDisabled = _ref.setDisabled,
      submitError = _ref.submitError,
      setSubmitError = _ref.setSubmitError,
      handleSubmit = _ref.handleSubmit,
      ariaLabel = _ref.ariaLabel;
  var ref = (0,react.useRef)(null);

  var handleComplete = function handleComplete(code) {
    setSubmitCode(code);
    setDisabled(false);
    if (submitError !== "בוצעו יותר מדי נסיונות כושלים, נסו שוב עוד דקה") setSubmitError(null);
    setTimeout(function () {
      handleSubmit(code);
    }, 1000);
  };

  (0,react.useEffect)(function () {
    if (ref.current && ref.current.iRefs && ref.current.iRefs[0] && ariaLabel) {
      ref.current.iRefs[0].current.setAttribute("aria-label", ariaLabel);
    }
  }, [ariaLabel]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCodeWrapper, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledeInput, {
      ref: ref,
      type: "number",
      fields: 4,
      fieldHeight: 56,
      fieldWidth: 48,
      autoFocus: true,
      onComplete: handleComplete,
      onChange: function onChange() {
        return setDisabled(true);
      },
      $submitError: submitError
    })
  });
};

/* harmony default export */ var OtpStep_StyledCodeInput = (StyledCodeInput);
;// CONCATENATED MODULE: ./components/OtpStep/Timer.tsx






var StyledBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "Timer__StyledBox",
  componentId: "sc-1pt9eim-0"
})(["margin-top:40px;"]);
var StyledText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "h4"
}).withConfig({
  displayName: "Timer__StyledText",
  componentId: "sc-1pt9eim-1"
})(["color:", ";font-size:40px;"], function (p) {
  return p.$color;
});

var Timer = function Timer(_ref) {
  var mins = _ref.mins,
      secs = _ref.secs,
      setTime = _ref.setTime;

  var _useState = (0,react.useState)(null),
      timeLeft = _useState[0],
      setTimeLeft = _useState[1];

  var calculateTime = function calculateTime() {
    if (secs === 0 || secs % 5 === 0) {
      setTimeLeft("\u05E0\u05E9\u05D0\u05E8 ".concat(mins, " \u05D3\u05E7\u05D5\u05EA \u05D5 ").concat(secs, " \u05E9\u05E0\u05D9\u05D5\u05EA"));
    }

    if (mins === 0 && secs === 0) {
      setTime([0, 0]);
    } else if (secs === 0) {
      setTime([mins - 1, 59]);
    } else {
      setTime([mins, secs - 1]);
    }
  };

  (0,react.useEffect)(function () {
    var timer = setInterval(function () {
      return calculateTime();
    }, 1000);
    return function () {
      clearInterval(timer);
    };
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledBox, {
    role: "timer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
      role: "alert",
      variant: "srOnly",
      children: timeLeft
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledText, {
      $color: mins === 0 && secs === 0 ? "#757575" : "#000000",
      children: "".concat(mins.toString().padStart(2, "0"), ":").concat(secs.toString().padStart(2, "0"))
    })]
  });
};

/* harmony default export */ var OtpStep_Timer = (Timer);
;// CONCATENATED MODULE: ./components/OtpStep/OtpPage.tsx
























var RECAPTCHA_KEY = "6LdBc5YiAAAAABjC-OWsg7BFb01Rd-j-nwJcXLx-";

if (!RECAPTCHA_KEY) {
  throw new Error("Please provide the RECAPTCHA_KEY environment variable.");
}

var StyledWrapper = (0,styled_components_browser_esm/* default */.ZP)(Container/* default */.Z).withConfig({
  displayName: "OtpPage__StyledWrapper",
  componentId: "sc-1yd707o-0"
})(["margin-top:80px;position:relative;padding:0px;padding-bottom:70px;", "{margin-top:0px;padding-right:60px;padding-left:60px;display:flex;flex-grow:1;justify-content:center;align-items:center;}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "h2"
}).withConfig({
  displayName: "OtpPage__StyledTitle",
  componentId: "sc-1yd707o-1"
})(["font-size:40px;color:#000;line-height:120%;letter-spacing:-0.02em;font-family:Speedee,NarkisBlock;", "{margin-top:64px;line-height:0.8;margin-bottom:4px;padding:0 16px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var OtpPage_StyledText = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "OtpPage__StyledText",
  componentId: "sc-1yd707o-2"
})(["line-height:1.1;font-weight:", ";margin-top:", ";", "{font-size:24px;span{font-size:20px;}}"], function (p) {
  return p.$fontWeight;
}, function (p) {
  return p.$marginTop;
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "OtpPage__StyledLink",
  componentId: "sc-1yd707o-3"
})(["a{display:flex;}p{margin-right:8px;}", "{position:absolute;top:120px;right:60px;}", "{margin-right:16px;padding-top:16px;}:hover{text-decoration:underline;}"], function (p) {
  return p.theme.breakpoints.up("md");
}, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledActionsWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OtpPage__StyledActionsWrap",
  componentId: "sc-1yd707o-4"
})(["margin-top:75px;display:flex;justify-content:center;gap:20px;", "{margin-top:23px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledButtonLink = (0,styled_components_browser_esm/* default */.ZP)(Link/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "OtpPage__StyledButtonLink",
  componentId: "sc-1yd707o-5"
})(["color:", ";font-size:24px;pointer-events:", ";font-family:\"Speedee\",\"NarkisBlock\";font-weight:bold;text-decoration:none;:hover{text-decoration:underline;}", "{font-size:24px;}"], function (p) {
  return p.$disabled ? "#264f36" : "#757575;";
}, function (p) {
  return p.$disabled ? "auto" : "none";
}, function (p) {
  return p.theme.breakpoints.up("md");
});
var StyledButtonWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "OtpPage__StyledButtonWrapper",
  componentId: "sc-1yd707o-6"
})(["width:100%;height:50px;margin-top:70px;display:flex;justify-content:center;", "{width:100%;position:fixed;right:0;border-radius:10px;box-shadow:0 -5px 10px 0 hsla(0,0%,0%,0.12);background-color:#fff;padding:12px 16px 10px 16px;height:70px;bottom:0;margin-top:0px;z-index:10;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledError = (0,styled_components_browser_esm/* default */.ZP)(Typography/* default */.Z).attrs({
  variant: "body1"
}).withConfig({
  displayName: "OtpPage__StyledError",
  componentId: "sc-1yd707o-7"
})(["color:#d70202;line-height:1.1;", "{width:90%;margin:0 auto;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledTextWrapper = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "OtpPage__StyledTextWrapper",
  componentId: "sc-1yd707o-8"
})(["", "{display:flex;justify-content:center;:nth-child(2){P{margin-right:5px;}}}"], function (p) {
  return p.theme.breakpoints.up("md");
});
var OtpPage_StyledBox = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).withConfig({
  displayName: "OtpPage__StyledBox",
  componentId: "sc-1yd707o-9"
})(["margin-top:120px;", "{margin-top:59px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledSMSText = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "OtpPage__StyledSMSText",
  componentId: "sc-1yd707o-10"
})(["font-family:Speedee;font-size:20px;", "{font-size:16px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});

var OtpPage = function OtpPage(_ref) {
  var type = _ref.type,
      submit = _ref.submit,
      editLink = _ref.editLink,
      prevPathLink = _ref.prevPathLink;

  var _useOtpContext = (0,OtpContext/* useOtpContext */.yQ)(),
      totalTimeoutInSeconds = _useOtpContext.totalTimeoutInSeconds,
      setTotalTimeoutInSeconds = _useOtpContext.setTotalTimeoutInSeconds,
      phoneNumber = _useOtpContext.phoneNumber,
      setAccessToken = _useOtpContext.setAccessToken;

  var _useQuickPurchaseCont = (0,QuickPurchaseContext/* useQuickPurchaseContext */.Nr)(),
      prevPath = _useQuickPurchaseCont.prevPath;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)([0, 0]),
      _useState$ = (0,slicedToArray/* default */.Z)(_useState[0], 2),
      mins = _useState$[0],
      secs = _useState$[1],
      setTime = _useState[1];

  var _useState2 = (0,react.useState)(null),
      submitCode = _useState2[0],
      setSubmitCode = _useState2[1];

  var _useState3 = (0,react.useState)(true),
      disabled = _useState3[0],
      setDisabled = _useState3[1];

  var _useState4 = (0,react.useState)(""),
      submitError = _useState4[0],
      setSubmitError = _useState4[1];

  var reCaptchaRef = /*#__PURE__*/(0,react.createRef)();
  (0,react.useEffect)(function () {
    var minutes = Math.floor(totalTimeoutInSeconds / 60);
    var seconds = totalTimeoutInSeconds - minutes * 60;
    setTime([minutes, parseInt(seconds.toFixed(0))]);
  }, [totalTimeoutInSeconds]);

  var hiddenText = function hiddenText() {
    if ((mins + 1) * 60 === 120) return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      sx: visuallyHidden/* default */.Z,
      role: "alert",
      "aria-live": "polite",
      children: "\u05E0\u05D5\u05EA\u05E8\u05D5 2 \u05D3\u05E7\u05D5\u05EA \u05E2\u05D3 \u05E9\u05E0\u05D9\u05EA\u05DF \u05D9\u05D4\u05D9\u05D4 \u05DC\u05E9\u05DC\u05D5\u05D7 \u05E7\u05D5\u05D3 \u05DE\u05D7\u05D3\u05E9"
    });else if ((mins + 1) * 60 === 60 && secs > 30) return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      sx: visuallyHidden/* default */.Z,
      role: "alert",
      "aria-live": "polite",
      children: "\u05E0\u05D5\u05EA\u05E8\u05D5 1 \u05D3\u05E7\u05D4 \u05E2\u05D3 \u05E9\u05E0\u05D9\u05EA\u05DF \u05D9\u05D4\u05D9\u05D4 \u05DC\u05E9\u05DC\u05D5\u05D7 \u05E7\u05D5\u05D3 \u05DE\u05D7\u05D3\u05E9"
    });else if (mins === 0 && secs < 30 && secs > 0) return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      sx: visuallyHidden/* default */.Z,
      role: "alert",
      "aria-live": "polite",
      children: "\u05E0\u05D5\u05EA\u05E8\u05D5 0.5 \u05D3\u05E7\u05D4 \u05E2\u05D3 \u05E9\u05E0\u05D9\u05EA\u05DF \u05D9\u05D4\u05D9\u05D4 \u05DC\u05E9\u05DC\u05D5\u05D7 \u05E7\u05D5\u05D3 \u05DE\u05D7\u05D3\u05E9"
    });else if (mins === 0 && secs === 0) return /*#__PURE__*/(0,jsx_runtime.jsx)(Box/* default */.Z, {
      sx: visuallyHidden/* default */.Z,
      role: "alert",
      "aria-live": "polite",
      children: "\u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05DC\u05D5\u05D7 \u05E7\u05D5\u05D3 \u05DE\u05D7\u05D3\u05E9"
    });
  };

  var getVerificationCodeAgain = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _reCaptchaRef$current, _reCaptchaRef$current2;

      var gRecaptchaResponse, response, totalTime;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              reCaptchaRef === null || reCaptchaRef === void 0 ? void 0 : (_reCaptchaRef$current = reCaptchaRef.current) === null || _reCaptchaRef$current === void 0 ? void 0 : _reCaptchaRef$current.reset();
              _context.next = 3;
              return reCaptchaRef === null || reCaptchaRef === void 0 ? void 0 : (_reCaptchaRef$current2 = reCaptchaRef.current) === null || _reCaptchaRef$current2 === void 0 ? void 0 : _reCaptchaRef$current2.executeAsync();

            case 3:
              gRecaptchaResponse = _context.sent;
              setTotalTimeoutInSeconds(0);
              _context.next = 7;
              return (0,api.postGiftCardGenerateVerificationCode)({
                mobilePhone: phoneNumber,
                toSendSms: true,
                gRecaptchaResponse: gRecaptchaResponse
              });

            case 7:
              response = _context.sent;

              if ((response === null || response === void 0 ? void 0 : response.status) === 200 && response !== null && response !== void 0 && response.data) {
                totalTime = response.data.body.totalTimeoutInSeconds;
                setTotalTimeoutInSeconds(totalTime);
              }

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getVerificationCodeAgain() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(code) {
      var otpCode, _response$data, response, _error$response;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              otpCode = submitCode || code;
              _context2.prev = 1;
              setDisabled(true);
              _context2.next = 5;
              return (0,api.postGiftCardVerifyMobilePhone)({
                verificationCode: otpCode,
                mobilePhone: phoneNumber
              });

            case 5:
              response = _context2.sent;

              if ((response === null || response === void 0 ? void 0 : response.status) === 200 && response !== null && response !== void 0 && response.data && response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.body) {
                setAccessToken(response.data.body.accessToken);
                (0,api.setApiToken)(response.data.body.accessToken);
                submit(true);
              } else if (response !== null && response !== void 0 && response.data && (response === null || response === void 0 ? void 0 : response.data.errorCode) === 429) {
                setSubmitError("בוצעו יותר מדי נסיונות כושלים, נסו שוב עוד דקה");
              } else if (response !== null && response !== void 0 && response.data && (response === null || response === void 0 ? void 0 : response.data.errorCode) === 2000) {
                submit(false);
              } else {
                setSubmitError("הקוד אינו תקין, בבקשה לנסות שוב");
              } // submit(
              //   !!(response?.status === 200 && response?.data && response?.data?.body)
              // )


              _context2.next = 12;
              break;

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](1);

              if ((_context2.t0 === null || _context2.t0 === void 0 ? void 0 : (_error$response = _context2.t0.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 429) {
                setSubmitError("בוצעו יותר מדי נסיונות כושלים, נסו שוב עוד דקה");
              } else {
                setSubmitError("הקוד אינו תקין, בבקשה לנסות שוב");
              }

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 9]]);
    }));

    return function handleSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(NextLink/* default */.Z, {
          href: prevPath || prevPathLink || type === "balance" ? "/balance" : type === "groupPurchases" ? "/groupPurchases" : "/preview",
          ariaLabel: "\u05D7\u05D6\u05E8\u05D4 \u05DC\u05E2\u05DE\u05D5\u05D3 \u05E7\u05D5\u05D3\u05DD",
          onClick: function onClick(e) {
            e.preventDefault();
            router.back();
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(BackIcon/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
            variant: "body1",
            children: "\u05D7\u05D6\u05E8\u05D4"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OtpPage_StyledBox, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTitle, {
          children: type === "purchase" || type === "groupPurchases" ? "הזדהות באמצעות קוד אימות - עושים אימות קטן, ומתקדמים" : "הזדהות באמצעות קוד אימות"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledTextWrapper, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(OtpPage_StyledText, {
            $fontWeight: "500",
            $marginTop: "0px",
            children: ["\u05D1\u05E8\u05D2\u05E2\u05D9\u05DD \u05D0\u05DC\u05D5 \u05E0\u05E9\u05DC\u05D7 \u05E7\u05D5\u05D3 \u05D1-", /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSMSText, {
              children: "SMS"
            }), " \u05DC\u05D8\u05DC\u05E4\u05D5\u05DF \u05D4\u05E0\u05D9\u05D9\u05D3 \u05E9\u05DC\u05DA", " "]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OtpPage_StyledText, {
            $fontWeight: "100",
            $marginTop: "0px",
            children: [" ", "\u05E9\u05DE\u05E1\u05E4\u05E8\u05D5 ", (0,formatters/* formatPhone */.CN)(phoneNumber)]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Typography/* default */.Z, {
          variant: "srOnly",
          children: "\u05E2\u05DC\u05D9\u05DA \u05DC\u05D4\u05D6\u05D9\u05DF \u05D0\u05EA \u05D4\u05E7\u05D5\u05D3 \u05DB\u05E4\u05D9 \u05E9\u05E7\u05D9\u05D1\u05DC\u05EA \u05D1\u05D4\u05D5\u05D3\u05E2\u05EA SMS"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Typography/* default */.Z, {
          variant: "body1",
          style: {
            fontWeight: 500,
            fontFamily: "NarkisBlock",
            marginTop: 40
          },
          children: ["\u05E2\u05DC\u05D9\u05DA \u05DC\u05D4\u05D6\u05D9\u05DF \u05D0\u05EA \u05D4\u05E7\u05D5\u05D3 \u05DB\u05E4\u05D9 \u05E9\u05E7\u05D9\u05D1\u05DC\u05EA \u05D1\u05D4\u05D5\u05D3\u05E2\u05EA", " ", /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSMSText, {
            children: "SMS"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(OtpStep_StyledCodeInput, {
          setSubmitCode: setSubmitCode,
          setDisabled: setDisabled,
          submitError: submitError,
          setSubmitError: setSubmitError,
          handleSubmit: handleSubmit,
          ariaLabel: "\u05E2\u05DC\u05D9\u05DA \u05DC\u05D4\u05D6\u05D9\u05DF \u05D0\u05EA \u05D4\u05E7\u05D5\u05D3 \u05E9\u05E0\u05E9\u05DC\u05D7 \u05D0\u05DC\u05D9\u05DA \u05DC\u05D8\u05E4\u05DC\u05D5\u05DF \u05D4\u05E0\u05D9\u05D9\u05D3"
        }), submitError && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledError, {
          children: submitError
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(OtpStep_Timer, {
          mins: mins,
          secs: secs,
          setTime: setTime
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledActionsWrap, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledButtonLink, {
            component: "button",
            onClick: getVerificationCodeAgain,
            $disabled: mins === 0 && secs === 0,
            children: "\u05E9\u05DC\u05D7\u05D5 \u05DC\u05D9 \u05E7\u05D5\u05D3 \u05D7\u05D3\u05E9"
          }), type === "purchase" ? /*#__PURE__*/(0,jsx_runtime.jsx)(NextLink/* default */.Z, {
            href: "".concat(editLink, "/?focus=senderMobilePhone"),
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButtonLink, {
              component: "a",
              $disabled: true,
              children: "\u05E2\u05E8\u05D9\u05DB\u05EA \u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF"
            })
          }) : type === "groupPurchases" && /*#__PURE__*/(0,jsx_runtime.jsx)(NextLink/* default */.Z, {
            href: "".concat(editLink, "/?focus=phoneNumber"),
            passHref: true,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButtonLink, {
              component: "a",
              $disabled: true,
              children: "\u05E2\u05E8\u05D9\u05DB\u05EA \u05DE\u05E1\u05E4\u05E8 \u05D8\u05DC\u05E4\u05D5\u05DF"
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledButtonWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(GenericButton/* default */.Z, {
            btnType: "filled",
            disabled: disabled || mins === 0 && secs === 0 || submitError ? true : false,
            onClick: handleSubmit,
            width: 328,
            children: "\u05D0\u05D9\u05E9\u05D5\u05E8"
          })
        }), hiddenText()]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(esm/* default */.Z, {
      ref: reCaptchaRef,
      sitekey: RECAPTCHA_KEY,
      size: "invisible",
      hl: "iw",
      tabIndex: -1
    })]
  });
};

/* harmony default export */ var OtpStep_OtpPage = (OtpPage);

/***/ })

}]);